<!--
 * $Description: 
 * $Author: Betway
 * $LastEditors: BetWay
 * $Date: 2020年03月17日 14:50:58 +0800
 * $LastEditTime: 2020年05月22日 11:51:29 +0800
 * $FilePath: /src/Page/EssAdmin/Home/components/MrcDatePicker.vue
 -->
<template>
  <div>
    <v-input class="pt-0">
      <template v-solt:default>
        <v-menu offset-y color="white" absolute :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-text-field
              :placeholder="placeholder"
              :filled="!disable"
              readonly
              dense
              hide-details
              :prepend-inner-icon="prependInnerIcon"
              :append-icon="(!disable&&date)?appendIcon:''"
              :value="date"
              @click:append="onClear"
              v-on="disable?null:on"
              single-line
              :rules="isRequire?$GetRules('_Require_Rules', [null]):[]"
            ></v-text-field>
          </template>
          <v-sheet color="white" width="300">
            <v-date-picker
              v-model="date"
              :min="min"
              :max="max"
              color="primary"
              landscape
              event-color="#fb8c00"
              header-color="#fb8c00"
              no-title
              show-current
              type="date"
            ></v-date-picker>
          </v-sheet>
        </v-menu>
      </template>
    </v-input>
  </div>
</template>
<script>
export default {
  name: "MrcTimePicker",
  props: {
    isEnd: { default: false, type: Boolean },
    disable: { default: false, type: Boolean },
    isRequire: { default: false, type: Boolean },
    appendIcon: { default: "close", type: String },
    prependInnerIcon: { default: "", type: String },
    value: { default: "", type: String },
    min: { default: "", type: String },
    max: { default: "", type: String },
    defaultTime: { default: "", type: String },
    placeholder: { default: "Date", type: String }
  },
  data() {
    return {
      day: 0,
      hour: "00",
      minute: "00",
      date: "",
      TimeMinute: 0
    };
  },
  watch: {
    date(val) {
      this.$emit("change", val);
    },
    value(val) {
      // console.log(val);
    },
    defaultTime(val) {
      this.date = val;
    }
  },
  methods: {
    onClear: function() {
      this.date = "";
    },
    timeMachine: function(day, hour, minute) {
      return Number(day) * 60 * 24 + Number(hour) * 60 + Number(minute);
    },
    setDay: function(day) {
      if (this.day == day) {
        this.day = 0;
      } else {
        this.day = day;
      }
      this.time =
        this.day == 0
          ? this.hour + ":" + this.minute
          : "(+" + this.day + "day)" + this.hour + ":" + this.minute;
      this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
    },
    setHour: function(hour) {
      this.hour = hour;
      this.time =
        this.day == 0
          ? this.hour + ":" + this.minute
          : "(+" + this.day + "day)" + this.hour + ":" + this.minute;
      this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
    },
    setMinute: function(minute) {
      this.minute = minute;
      this.time =
        this.day == 0
          ? this.hour + ":" + this.minute
          : "(+" + this.day + "day)" + this.hour + ":" + this.minute;
      this.TimeMinute = this.timeMachine(this.day, this.hour, this.minute);
    }
  }
};
</script>